import { useState, useEffect } from 'react';
import { fetchCourseUsers } from 'Api/editCourseLessons';

const useUsers = ({ courseId, lessonId }) => {
  const [users, setUsers] = useState([]);
  const [enrolledUsers, setEnrolledUsers] = useState([]);

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      fetchCourseUsers({ lessonId, courseId }).then(data => {
        setUsers(data.courseUsers);
        if (data?.enrolledUsers) {
          setEnrolledUsers(data.enrolledUsers);
        }
      });
    }

    return () => {
      isMounted = false;
      setUsers([]);
      setEnrolledUsers([]);
    };
  }, [lessonId, courseId]);

  return {
    users,
    enrolledUsers,
  };
};

export default useUsers;
